// RenderTrackerService.ts
import { BehaviorSubject } from 'rxjs';

type RenderCounts = Record<string, number>;

class RenderTrackingService {
	private static instance: RenderTrackingService;
	private renderCounts: RenderCounts = {};
	private subject = new BehaviorSubject<RenderCounts>({});
	private enabled = false;

	// private constructor () {}

	static getInstance (): RenderTrackingService {
		if (!RenderTrackingService.instance) {
			RenderTrackingService.instance = new RenderTrackingService();
		}
		return RenderTrackingService.instance;
	}

	setEnabled (enabled: boolean): void {
		this.enabled = enabled;
		if (!enabled) {
			this.reset(); // optionally clear counts when disabling
		}
	}

	isEnabled (): boolean {
		return this.enabled;
	}

	incrementRender (componentName: string): void {
		if (!this.enabled) return;

		if (!this.renderCounts[componentName]) {
			this.renderCounts[componentName] = 0;
		}
		this.renderCounts[componentName]++;
		this.subject.next({ ...this.renderCounts });
	}

	getRenderCounts$ () {
		return this.subject.asObservable();
	}

	reset (): void {
		this.renderCounts = {};
		this.subject.next({});
	}
}

export const renderTracking = RenderTrackingService.getInstance();
